
import { createI18n } from 'vue-i18n'		//引入vue-i18n组件
import cn from './locales/cn'
import en from './locales/en'
const i18n = createI18n({
    legacy: false,
    locale: 'en',

  globalInjection: true,
    messages: { cn, en }
  })
  
  export default i18n